import React from 'react';

import { cn } from '../../lib/utils';

export interface ConversationStatusProps {
  className?: string;
}

export const ConversationStatus = ({ className }: ConversationStatusProps) => {
  return (
    <span
      className={cn(
        'text-sm font-medium animate-sweep bg-sweep-yellowfin bg-clip-text text-transparent [background-size:200%_auto]',
        className,
      )}
    >
      Working...
    </span>
  );
};
